import Calendar from 'components/calendar/Calendar'
import { useContext, useEffect, useState } from 'react'
import { fmt } from 'components/calendar/calendarUtil'
import {
  CalendarContext,
  DatePickerContext,
} from 'components/calendar/CalendarContext'
import classNames from 'classnames'
import Icon from 'components/Icon'
import { isNullOrUndefined } from 'utils'
import NoneAnchor from '../NoneAnchor'

const SingleMonthLayer = () => {
  const { min, max, close, reset, onChange } = useContext(CalendarContext)
  const { value, month, setMonth } = useContext(DatePickerContext)
  const minMonth = min ? min.clone().startOf('month') : null
  const maxMonth = max ? max.clone().startOf('month') : null
  const [disabled, setDisabled] = useState(isNullOrUndefined(value))
  useEffect(() => {
    setDisabled(isNullOrUndefined(value))
  }, [value])
  const handleCancel = () => {
    close()
    reset()
  }
  const handleSubmit = () => {
    onChange(value ? value.format(fmt) : '')
    close()
    reset()
  }
  const prev = () => {
    setMonth(month.subtract(1, 'months').clone())
  }
  const next = () => {
    setMonth(month.add(1, 'months').clone())
  }
  return (
    <div className="calendar_layer">
      <div className="inner_calendar_layer">
        <div className="layer_head">
          <strong className="screen_out">날짜 선택 달력</strong>
        </div>
        <div className="layer_body">
          <div className="date_calendar">
            <div className="datecalendar_wrap">
              <div className="inner_datecalendar">
                <div className="box_datecalendar">
                  <div className="setdetail_calendar">
                    <Calendar type="single" month={month} />
                    <button
                      type="button"
                      className={classNames('btn_move btn_prev', {
                        in_active:
                          minMonth && month.isSameOrBefore(minMonth, 'days'),
                      })}
                      disabled={
                        minMonth && month.isSameOrBefore(minMonth, 'days')
                      }
                      onClick={prev}>
                      <Icon name="arr">이전</Icon>
                    </button>
                    <button
                      type="button"
                      className={classNames('btn_move btn_next', {
                        in_active:
                          maxMonth && month.isSameOrAfter(maxMonth, 'days'),
                      })}
                      disabled={
                        maxMonth && month.isSameOrAfter(maxMonth, 'days')
                      }
                      onClick={next}>
                      <Icon name="arr">다음</Icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="btn_wrap">
              <button
                type="button"
                className={classNames('btn_gm gm_bl', {
                  in_active: disabled,
                })}
                onClick={handleSubmit}
                disabled={disabled}>
                <span className="inner_g">적용</span>
              </button>
              <NoneAnchor className="btn_gm" onClick={handleCancel}>
                <span className="inner_g">취소</span>
              </NoneAnchor>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SingleMonthLayer
